import { useAppStore } from '@/store/useAppStore.ts'
import { SolveMode, type SolveMode as SolveModeType } from '@brt/shared-types'
import { HelpIcon } from '@/components/shared/HelpIcon.tsx'

const MODES: { value: SolveModeType; label: string }[] = [
  { value: SolveMode.RUNTIME, label: 'Runtime' },
  { value: SolveMode.BATTERY_SIZE, label: 'Battery Size' },
  { value: SolveMode.MAX_LOAD, label: 'Max Load' },
]

export function SolveModeSelector() {
  const solveMode = useAppStore((s) => s.solveMode)
  const setSolveMode = useAppStore((s) => s.setSolveMode)

  return (
    <div className="solve-mode-selector" role="radiogroup" aria-label="Solve mode">
      <HelpIcon text="Runtime: how long the battery lasts under load. Battery Size: minimum Ah needed for a target runtime. Max Load: highest sustainable current for a target runtime.">
        <span className="solve-mode-selector__label">Solve For</span>
      </HelpIcon>
      {MODES.map((mode) => (
        <button
          key={mode.value}
          type="button"
          role="radio"
          aria-checked={solveMode === mode.value}
          className={`solve-mode-selector__btn ${solveMode === mode.value ? 'solve-mode-selector__btn--active' : ''}`}
          onClick={() => setSolveMode(mode.value)}
        >
          {mode.label}
        </button>
      ))}
    </div>
  )
}
